export const HEADERS = ['Product', 'Spend', 'Leads', 'CPL (Netto)'];
